import type { DayOutlook } from '../../types/weather';

function outlookColor(label: string): string {
  if (label === 'Excellent') return 'text-emerald-600 dark:text-emerald-400';
  if (label === 'Good')      return 'text-green-600 dark:text-green-500';
  if (label === 'Fair')      return 'text-amber-600 dark:text-amber-400';
  return 'text-red-600 dark:text-red-400';
}

function cardinal(deg: number): string {
  const dirs = ['N','NE','E','SE','S','SW','W','NW'];
  return dirs[Math.round(((deg % 360) / 45)) % 8];
}

function DayTile({ day }: { day: DayOutlook }) {
  const dow = new Date(day.date + 'T12:00:00')
    .toLocaleDateString('en-US', { weekday: 'short' });
  const windStr = day.windGustsMph >= 15
    ? `${Math.round(day.windMph)} g${Math.round(day.windGustsMph)}`
    : `${Math.round(day.windMph)}`;

  return (
    <div className="text-center px-1 py-2 rounded-lg" title={`${day.label} fishing conditions`}>
      <div className="text-[10px] font-bold tracking-wide text-slate-500 dark:text-slate-400 mb-1">{dow}</div>
      <div className="text-lg mb-0.5">🐟</div>
      <div className={`text-[11px] font-semibold mb-1 ${outlookColor(day.label)}`}>{day.label}</div>
      <div className="text-[12px] mb-0.5 whitespace-nowrap">
        <span className="font-semibold text-slate-800 dark:text-slate-100">{Math.round(day.tempHighF)}°</span>
        <span className="text-slate-500 dark:text-slate-400">/{Math.round(day.tempLowF)}°</span>
      </div>
      <div
        className="text-[10px] text-slate-600 dark:text-slate-300 whitespace-nowrap"
        title={`Feels ${Math.round(day.apparentHighF)}°/${Math.round(day.apparentLowF)}°`}
      >
        {windStr} {cardinal(day.windDirDeg)}
      </div>
      <div className="text-[10px] text-slate-600 dark:text-slate-300">💧 {day.precipChancePct}%</div>
      <div className="text-[10px] text-slate-500 dark:text-slate-400">UV {day.uvIndexMax.toFixed(0)}</div>
    </div>
  );
}

export function WeekStrip({ days }: { days: DayOutlook[] }) {
  return (
    <div className="grid grid-cols-3 sm:grid-cols-6 gap-1">
      {days.map(d => <DayTile key={d.date} day={d} />)}
    </div>
  );
}
